import { Box, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl, salesManagement } from "../../../config";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { PurchaseOrderPayments } from "../../../data/DynamicTable/Collumns";

function PurchaseOrderPaymentMethod() {
  const navigate = useNavigate(); // Initialize navigate hook
  const data = JSON.parse(localStorage.getItem("PurchaseOrderData"));
  const base_url = AccountsandFinanceurl.uri;
  const actions = {
    entity: "PurchaseOrderItems",
    isSubRight: true,
    dataObject: {
      inputFields: { purchaseOrderId: data.id },
      inputObjectName: "allPaymentVoucherPaymentMethodsWithSpecificColumn",
      inputSubObjectName: "param",
      returnFields: [
        "pvId",
        "purchaseOrderId",
        "vendorId",
        "paymentMethodId",
        "paymentMethodName",
        "paymentAccountId",
        "amountPaid",
        "paymentDate",
        "reference",
        "remarks",
        "isActive",
        // "pvStatus",
        "createdBy",
        "approvedBy",
        "createdDate",
        "approvedDate",
        "updatedDate",
        "updatedBy",
        "companyId",
        "rejectedBy",
        "rejectedDate",

      ],
    },
    showStatus: true,
    pvPaymentStatus: true,
  };
  const unignoredIds = ["id"];
  const ignore = ["createdBy"];
  return (
    <Box m="2px">
      {/* Back Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)} // Go back to the previous page
        sx={{ marginBottom: "10px" }}
      >
        Back
      </Button>{" "}
      {/* Dynamic Table */}
      <DynamicTable
        title="Purchase Order Payments"
        subtitle="View Payment Methods"
        ignoreFields={ignore}
        unignoredIds={unignoredIds}
        // FormComponent={PurchaseOrderItemsForm}
        //  publish
        columns={PurchaseOrderPayments}
        base_url={base_url}
        actions={actions}
        getRowId={(row) => row.pvId}
      />
    </Box>
  );
}
export default PurchaseOrderPaymentMethod;
